import ParkingCard from '@components/ParkingCard/ParkingCard.component'
import { DateTime } from 'luxon'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SpecificCarpayCard } from '../CarpayOrderCard.component'
import CarpayOrderCardContent from '../CarpayOrderCardContent.component'
import CarpayOrderCardHeader from '../CarpayOrderCardHeader.component'

const PaidCarpayOrderCard = ({
    order,
    discount,
    priceToBePaid,
    isLast,
    disabled,
    onClick,
    currency
}: SpecificCarpayCard) => {
    const { t } = useTranslation()
    const endDate = DateTime.fromISO(order.end_date ?? DateTime.now().toISO())
    const startDate = DateTime.fromISO(order.start_date)
    const elapsetTimeFromEntrance = endDate.diff(startDate).shiftTo('hours', 'minutes').toFormat("h'h' m'm'")

    return (
        <ParkingCard isLast={isLast} disabled={disabled} onClick={onClick}>
            <CarpayOrderCardHeader
                text={startDate.toFormat('dd.MM.yyyy')}
                badgeText={t('carpay.orderStatuses.paid')}
                badgeVariant="information"
            />

            <CarpayOrderCardContent
                title={t('carpay.orderCard.price')}
                subtitle={`${t('carpay.orderCard.duration')}: ${elapsetTimeFromEntrance}`}
                price={priceToBePaid}
                discount={discount}
                currency={currency}
            />
        </ParkingCard>
    )
}

export default PaidCarpayOrderCard
